import React, { useEffect } from 'react';
import { Popover, Button, Progress } from 'antd';

import { LOAD_EVENTS_TIME_LIVE_PAGE } from '../../../config/constants';
import { useInterval } from '../../../helpers/customHooks';
import { fixDecimals } from '../../../helpers/helpers';

const content = (
  <div style={{ display: 'flex' }}>
    <div style={{ width: '567px' }}>
      <p><b>Your Live Practice recently ended. </b></p>
      <p>We’re now processing your full practice data and it should be available within 30 minutes.</p>
    </div>
    <div style={{ textAlign: 'right', width: '105px' }}>
      <Button>Dismiss</Button>
    </div>
  </div>
);

export const ProgressBar = ({ loadDataProcessingStatus, hidden, completePercent, endTime, teamId }) => {
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  useEffect(() => {
    if(!isMobile)loadDataProcessingStatus(endTime, teamId, true);
  }, []);
  useInterval(() => {
    loadDataProcessingStatus(endTime, teamId, true);
  },!isMobile && !hidden ? LOAD_EVENTS_TIME_LIVE_PAGE : null);
  return (
    <Popover overlayClassName="popover-blue" content={content}>
      <div className="livebar" style={{ position: 'absolute', bottom: 0, zIndex: '2000' }}>
        <p style={{ width: '190px' }}>
          Practice Data Processing
        </p>
        <Progress percent={isNaN(+completePercent) ? 0 : fixDecimals(+completePercent*100,0)} size="small" status="active" />
      </div>
    </Popover>
  );
};
